import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import '../../scss/reusables/snackbar.scss';

export default function Snackbars(props) {
    var {open, setOpen, error, severity, message} = props
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <div className="snackbar-plugin-container">
            <div>
                {severity != "warning" ? 
                <div className="success-container">
                    <Snackbar open={open} autoHideDuration={6000} anchorOrigin={{ vertical: "top", horizontal: "right" }} onClose={handleClose}>
                        {severity == "success" ? 
                        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                            {message}
                        </Alert> :
                        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                            {error}
                        </Alert>}
                    </Snackbar>
                </div> : 
                <div className="warning-container">
                    <Snackbar open={open} anchorOrigin={{ vertical: "top", horizontal: "right" }} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }}>
                            {message}
                        </Alert>
                    </Snackbar>
                </div>
                }
            </div>  
        </div>
    )
}